import {HttpClient, HttpClientModule} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpModule} from '@angular/http';

import './rxjs-extensions';

import {AppRoutingModule} from './app-routing.module';

import {AppComponent} from './app.component';
import {CoreModule} from './core/core.module';
// import {ConnectorModule} from './connector/connector.module';
import {ConfigModule} from './config/config.module';
import {CrmModule} from './crm/crm.module';
import {ProductModule} from './product/product.module';
import {UserModule} from './users/user.module';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {ToastrModule} from 'ngx-toastr';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AngularLoadingBarModule} from 'ng4-loader-bar';
import {WeclomeComponent} from './welcome-page/welcome-page';

import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { OrderModule } from 'ngx-order-pipe';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient, '../assets/i18n/', '.json');
}

import { registerLocaleData, APP_BASE_HREF } from '@angular/common';
import localeDe from '@angular/common/locales/de';

// the second parameter 'fr' is optional
registerLocaleData(localeDe, 'de');


@NgModule({
    declarations: [AppComponent, WeclomeComponent],
    imports: [
        BrowserModule,
        HttpModule,
        NgbModule.forRoot(),
        CoreModule,
        ProductModule,
        ConfigModule,
        HttpClientModule,
        UserModule,
        AppRoutingModule,
        AngularLoadingBarModule.forRoot(),
        NgxMyDatePickerModule.forRoot(),
        ToastrModule.forRoot(),
        BrowserAnimationsModule,
        OrderModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports: [TranslateModule],
    bootstrap: [AppComponent]
})



export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts